import { ArrowDown } from '@ui/components/icons';
import { getErc20Tokens, getPayablePoolTokens } from '@ui/constants/tokens';
import { useDataChainId } from '@ui/hooks/datachain';
import { Button } from '@ui/lib/park/ui/button';
import { Icon } from '@ui/lib/park/ui/icon';
import { Text } from '@ui/lib/park/ui/text';
import { PayablePoolToken, Token } from '@ui/types/token';
import { useTranslation } from 'next-i18next';
import { useMemo, useState } from 'react';
import { Box, HStack, styled, VStack } from 'styled-system/jsx';

import { TokenPicker } from './TokenPicker/TokenPicker';

type Props = {
  setToken?: (token: Token) => void;
  token: Token | undefined;
  payableTokens: readonly Token[];
};

export const InputToken = ({ setToken, token, payableTokens }: Props) => {
  const { t } = useTranslation();
  const chainId = useDataChainId();

  if (setToken && payableTokens.length > 1) {
    return (
      <TokenPicker
        payableTokens={payableTokens}
        onSelect={setToken}
        title={t('common.Pick Collateral Token')}
      >
        <Button
          minH="32px"
          minW="82px"
          variant="outline"
          borderRadius="4px"
          p="8px 12px"
          data-cy="TokenPicker"
        >
          {token?.image && (
            <styled.img
              src={token?.image}
              alt="token icon"
              width="16px"
              height="16px"
            />
          )}
          <Text textStyle="text.large">{token?.displaySymbol || '---'}</Text>
          <Icon boxSize="16px">
            <ArrowDown />
          </Icon>
        </Button>
      </TokenPicker>
    );
  }

  return (
    <HStack minH="32px" gap={1}>
      {token?.image && (
        <styled.img
          src={token?.image}
          alt="token icon"
          width="16px"
          height="16px"
        />
      )}
      <Text textStyle="text.large">{token?.displaySymbol || '---'}</Text>
    </HStack>
  );
};
